import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';

@Injectable()
export class HomeService {

  getSegmento(): Observable<HttpResponse<any>> {
    return this.http.get(
      environment.webApiSaguiControlUrl + '/api/saguicliente/saguicliente-segmento', { observe: 'response' })
  }


  getAcessoFuncionalidade(rota: any): Observable<HttpResponse<any>> {
        
    const params = {
      rota: rota,
       
    }
    return this.http.get(
        environment.webApiSaguiControlUrl + '/api/usuario/verificaacessoafuncionalidade/', { observe: 'response', params })
  }


  constructor(private http: HttpClient, private sanitizer: DomSanitizer) {

  }
}
